import {palette} from 'styled-tools'
import styled from 'styled-components'
import {media} from 'styled-bootstrap-grid'

import {styledTheme} from '@festi/common/themes'
import {useCommonContext} from '@festi/common/contexts/common'

const Title = styled.h2`
  font-size: 24px;
  font-weight: 500;
  line-height: 30px;
  color: ${styledTheme.palette.blue};
  padding-bottom: 4px;

  ${media.md`
    font-size: 32px;
    line-height: 40px;
  `};
`

const Sku = styled.span`
  padding-top: 4px;
  font-size: 1rem;
  color: ${palette('ui40Solid')};
  font-weight: 500;
  line-height: 1;
`

interface ProductHeaderProps {
  name: string
  sku: string
}

export default function ProductTitle({name, sku}: ProductHeaderProps) {
  const {handleCopyText} = useCommonContext()

  return (
    <div>
      <Title>{name}</Title>

      <Sku onClick={(e) => handleCopyText(e, sku)}>{sku}</Sku>
    </div>
  )
}
